import queryGQL from "@/Apollo/query/package-cart/packageCart.graphql";
import { Currency, PackageCartFragmentFragment } from "@/Apollo/schema";
import { ApolloCache } from "@apollo/client";

/**
 * The package cart is an unidentified (id-less) singleton, so Apollo cannot
 * normalise it automatically. Write the cart returned by a mutation straight
 * into the `PackageCart` query so active consumers refresh without a refetch.
 */
export const writePackageCartToCache = (
  cache: ApolloCache<unknown>,
  packageCart?: PackageCartFragmentFragment | null,
  displayCurrency?: Currency
) => {
  if (!packageCart) {
    return;
  }

  cache.writeQuery({
    query: queryGQL,
    variables: { displayCurrency },
    data: { packageCart },
  });
};
